// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CardLookupIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CardLookup/outline"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  d: "M1.663 7.083h8.75M4.997 13.75h1.666M8.747 13.75h3.333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.33 10.025v3.4c0 2.925-.741 3.658-3.7 3.658H5.363c-2.958 0-3.7-.733-3.7-3.658v-6.85c0-2.925.742-3.658 3.7-3.658H9.58M15.247 6.228a2.286 2.286 0 1 0 0-4.572 2.286 2.286 0 0 0 0 4.572ZM17.962 6.656l-.715-.714"
})));
export default CardLookupIcon;
